export default {
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  status: state => state.status,
  filterBy: state => state.filterBy,
  serviceRequest: state => state.serviceRequest,
  serviceRequests: state => state.serviceRequests,
  requestHistory: state => state.requestHistory,
  issues: state => state.issues
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/getters.js